import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const GetSharedDetailsStyles = css`
  .delivery-options-wrapper {
    display: flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    margin: 0 -3.7vw;
  }
  .dlv-opt-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    width: 100%;
  }
  .whitelabel {
    border: none;
    box-shadow: none;
  }
  .marginWrapper {
    padding-top: 16px;
    position: relative;
    margin: 0 -3.7vw;
    width: 100%;
  }
  .services-divider {
    border-bottom: 1px solid ${colors.white.shade4};
  }
`;
export { GetSharedDetailsStyles };
